module.exports = __webpack_public_path__ + "static/media/PATINEX_serviceblow2_eng.00872ed7.jpg";